import * as React from 'react';

const BigEqualIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={32}
      height={32}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h32v32H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#004A68"
        d="M7.178 13.98a1.78 1.78 0 0 1-1.307-.54 1.78 1.78 0 0 1-.539-1.307v-4.95c0-.513.18-.95.539-1.308a1.78 1.78 0 0 1 1.307-.54H24.82c.513 0 .948.18 1.308.54.359.359.538.795.538 1.307v4.951c0 .513-.18.949-.538 1.308a1.78 1.78 0 0 1-1.308.538H7.18Zm0-1.026H24.82a.8.8 0 0 0 .59-.23.799.799 0 0 0 .23-.59V7.181a.799.799 0 0 0-.23-.59.799.799 0 0 0-.59-.23H7.18a.799.799 0 0 0-.59.23.799.799 0 0 0-.231.59v4.951c0 .24.077.436.23.59.154.154.35.23.59.23Zm0 13.715a1.78 1.78 0 0 1-1.307-.538 1.78 1.78 0 0 1-.539-1.308V19.89c0-.513.18-.948.539-1.308a1.78 1.78 0 0 1 1.307-.538H24.82c.513 0 .948.18 1.308.538.359.36.538.795.538 1.308v4.933c0 .512-.18.948-.538 1.308a1.78 1.78 0 0 1-1.308.538H7.18Zm0-1.025H24.82c.24 0 .436-.077.59-.231a.799.799 0 0 0 .23-.59V19.89a.799.799 0 0 0-.23-.59.799.799 0 0 0-.59-.23H7.18a.799.799 0 0 0-.59.23.799.799 0 0 0-.231.59v4.933c0 .24.077.436.23.59.154.154.35.23.59.23Z"
      />
    </g>
  </svg>
);

export default BigEqualIcon;
